import React from "react";
import { useNavigate } from "react-router-dom";
import "./MenuModal.css";

export default function MenuModal({ routeMap, icons, labels, onClose }) {
  const navigate = useNavigate();

  return (
    <div className="menu-modal">
      <button className="close-btn" onClick={onClose}>×</button>
      <div className="tiles-grid">
        {Object.keys(routeMap).map((key) => (
          <div
            key={key}
            className="menu-tile"
            onClick={() => {
              navigate(`/${routeMap[key]}`);
              onClose();
            }}
          >
            <div className="tile-icon">{icons[key]}</div>
            <div className="tile-label">{labels[key] || key}</div>
          </div>
        ))}
      </div>
    </div>
  );
}
